import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    title: {
      inputType: 'text',
      title: 'Title',
      required: true,
    },
    days: {
      inputType: 'text',
      type: 'number',
      title: 'Days',
      required: true,
    },
    isOnlyExpiredDate: {
      inputType: 'togglebutton',
      title: 'Is Only Expired Date?',
      required: true,
    },
    isSeasoning: {
      inputType: 'togglebutton',
      title: 'Is Seasoning?',
      required: true,
    },
    // isCoBorrower: {
    //   inputType: 'togglebutton',
    //   title: 'Is Coborrower?',
    //   required: true,
    // },
  }
}
